import React from "react";
import { TourTypeOptions } from "../TourTypeOptions";
import TourTypeCard from "../TourTypeCard";
export var StepType = function (_a) {
    var onUpdate = _a.onUpdate, onNext = _a.onNext, tourTypes = _a.tourTypes;
    var handleSelectType = function (type) {
        onUpdate({ tourType: type });
        onNext();
    };
    return (React.createElement("div", { className: "flex flex-col items-center" },
        React.createElement("h3", { className: "text-xl font-semibold mb-6 text-center" }, "How would you like to tour?"),
        React.createElement("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-2xl" }, tourTypes.map(function (type) {
            var option = TourTypeOptions.find(function (o) { return o.label == type; });
            if (!option)
                return null;
            return (React.createElement(TourTypeCard, { key: option.value, option: option, onSelect: handleSelectType }));
        }))));
};
